export function formatDatum(datum) {
  if (!datum)
    return "";
  var d=new Date(datum);
  var day=d.getDate();
  var month=d.getMonth()+1;   // note: month is zero based!!!!
  var year=d.getFullYear();
  if (Number.isNaN(day) || !Number.isFinite(day))
    return "";
  if (Number.isNaN(month) || !Number.isFinite(month))
    return "";
  if (Number.isNaN(year) || !Number.isFinite(year))
    return "";
  return formatIntLeadingZeros(day,2) +"."+ formatIntLeadingZeros(month,2)+"."+year;
}

// expects a date object
export function formatIsoDate(date) {
  return date.getFullYear() +  "-"+ formatIntLeadingZeros(date.getMonth()+1,2)+"-"+formatIntLeadingZeros(date.getDate(),2);
}

// allows open ended period of days but start date is required.
// prints month and year only once if the same
export function pretty_print_datespan(date_start, date_end) {
  var start=new Date(date_start);
  var end = date_end ? new Date(date_end) : undefined;
  if (!end)
    return formatDatum(start) + ' - ...';
  if (start.getFullYear()==end.getFullYear()) {
    if (start.getMonth()==end.getMonth())
      return formatIntLeadingZeros(start.getDate(), 2) + ". - " + formatDatum(end);
    return formatIntLeadingZeros(start.getDate(), 2) + "." + formatIntLeadingZeros(start.getMonth() + 1, 2) + ". - " + formatDatum(end);
  }
  return formatDatum(start)+" - "+ formatDatum(end);
}

export function toUtc(datum) {
  if (!datum)
    return null;
  var d = new Date(datum);
  var utc=new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  return utc;
}

// note: max size 10 characters!
export function formatIntLeadingZeros(num, size) {
  var num_str=num.toString();
  if (num_str.length >= size)
    return num_str;
  var s = "000000000" + num_str;
  return s.substr(s.length-size);
}